import { nsXd } from "@qdabra/forms-shared/xmlNamespaces";
import { firstElementChild, getChildElements } from "../xmlUtility";

const $ = window.jQuery;

function sampleDataSourceAccessor(sampleDataSourceDom, xpathEvaluator) {

    // String -> DomNode
    function getSampleDom(dsname) {
        if (!dsname) {
            return sampleDataSourceDom;
        }

        const dsNode =
            getChildElements(sampleDataSourceDom.documentElement, 'DataConnection', nsXd)
                .find((node) => node.getAttribute('Name') === dsname);
        const dsRoot = dsNode && firstElementChild(dsNode);

        if (!dsRoot) {
            return null;
        }

        let newDoc = document.implementation.createDocument('', '', null);
        newDoc.appendChild(dsRoot.cloneNode(true));

        return newDoc;
    }

    // (String, String) -> DomNode
    function selectSampleNode(dsname, xpath) {
        const dom = getSampleDom(dsname);

        if (!dom) { return null; }

        return xpathEvaluator.evaluateXPath(xpath, { context: dom }).first();
    }

    return {
        getSampleDom,
        selectSampleNode,
    };
}

function sampleDataSource(template, xpathEvaluator) {
    function initAsync() {
        return template.getTemplateFileAsync('sampledata.xml')
            .then(function (fileXml) {
                return sampleDataSourceAccessor($.parseXML(fileXml), xpathEvaluator);
            });
    }

    return {
        initAsync,
    };
}

export default sampleDataSource;